import Vue from 'vue'
import Vuex from 'vuex'
import auth from "./auth";
import cart from "./cart";
import products from "./products";
import axios from 'axios'
import createMutationsSharer from "vuex-shared-mutations";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        lexicon: {},
        lang: 'uk',
    },
    mutations: {
        SET_LEXICON(state, lexicons) {
            state.lexicon = lexicons;
            window.drop_cart_updated = state.lexicon.drop_cart_updated
        },
        SET_LANG(state, lang) {
            state.lang = lang;
        },
    },
    actions: {

        async getLexicon({commit}) {
            let lang = 'uk';

            if (localStorage.getItem('user_lang')) {
                lang = localStorage.getItem('user_lang')
            }
            commit('SET_LANG', lang)
            commit('SET_LEXICON', window.localization)
            let lex = {};
            try {
                let response = await axios.get('lexicon/')
                commit('SET_LEXICON', response.data.data)
            } catch {
                if (typeof (lex.drop_dollar_sign) === "undefined" || !lex.drop_dollar_sign || lex.drop_dollar_sign !== '$') {
                    lex = window.localization;
                    commit('SET_LEXICON', lex)
                }
            }

        },
    },
    modules: {
        auth, cart, products
    },
    plugins: [
        createMutationsSharer({
            predicate: (mutation) => {
                const predicate = [
                    "auth/SET_USER",
                    "cart/pushProductToCart",
                    "cart/decrementItemQuantity",
                    "cart/incrementItemQuantity"
                ];
                return predicate.indexOf(mutation.type) >= 0;
            }
        })
    ]
})
